import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { authReducer } from './AuthReducer';
import { orderCodeReducer } from './EditOrderCodeReducer';
import { exchangeCodeReducer, importGoodsReducer, isCoppyReducer, packagesReducer } from './ImportionReducer';
import { cancelTicketReducer } from './CancellationReducer';
import { adjustmentTicketReducer } from './AdjustmentReducer';
import { exportGoodsReducer, isCoppyExportReducer, packagesExportReducer, } from './exportionReducer';
import { isCopyReturnReducer, returnGoodsReducer } from './ReturnReducer';
import { promotionReducer } from './PromotionReducer';

const authenSetup = {
    key: 'root',
    storage,
    whitelist: ['detail'],
};

const editOrderCodeSetup = {
    key: 'editOrder',
    storage,
    blackList: ['orderCode'],
};

const rootReducer = combineReducers({
    authReducer: persistReducer(authenSetup, authReducer),
    orderCodeReducer: persistReducer(editOrderCodeSetup, orderCodeReducer),

    importGoods: importGoodsReducer,
    isCopy: isCoppyReducer,
    exchangeCode: exchangeCodeReducer,

    handleOpenAddPackage: packagesReducer,
    cancellationTicket: cancelTicketReducer,
    adjustmentTicket: adjustmentTicketReducer,

    exportGoods: exportGoodsReducer,
    isCopyExport: isCoppyExportReducer,
    handleOpenAddPackageExport: packagesExportReducer,

    returnGoods: returnGoodsReducer,
    isCopyReturn: isCopyReturnReducer,

    promotion: promotionReducer,
});

export default rootReducer;
